/**
 * Update Cart Item Use Case
 */

import { ICartService } from '@/domain/services/cart.service.interface';
import { CartEntity } from '@/domain/entities/cart.entity';

export interface UpdateCartItemInput {
  cartToken: string;
  productId: string;
  variantId: string;
  quantity: number;
}

export interface UpdateCartItemOutput {
  cart: CartEntity;
}

export class UpdateCartItemUseCase {
  constructor(private readonly cartService: ICartService) {}

  async execute(input: UpdateCartItemInput): Promise<UpdateCartItemOutput> {
    if (!input.cartToken) {
      throw new Error('Cart token is required');
    }

    if (!input.productId) {
      throw new Error('Product ID is required');
    }

    if (!input.variantId) {
      throw new Error('Variant ID is required');
    }

    if (input.quantity < 0) {
      throw new Error('Quantity cannot be negative');
    }

    if (input.quantity === 0) {
      // Remove item instead
      const cart = await this.cartService.removeCartItem(
        input.cartToken,
        input.productId,
        input.variantId
      );
      return { cart };
    }

    const cart = await this.cartService.updateCartItem(
      input.cartToken,
      input.productId,
      input.variantId,
      input.quantity
    );

    return { cart };
  }
}

